import React, { useState, useRef } from "react";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import ICONS from "../Constants/Icons.tsx";

interface ShareButtonProps {
  link: string;
  onCopy?: () => void;
}

const ShareButton: React.FC<ShareButtonProps> = ({ link, onCopy }) => {
  const [tooltipText, setTooltipText] = useState("Copy link");
  const Icon = ICONS();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    const fullLink = `${window.location.origin}${link}`;
    navigator.clipboard.writeText(fullLink);    
    if (onCopy) {
      onCopy();
    }
    setTimeout(() => setTooltipText("Copy link"), 2000);
  };

  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        rounded
        onClick={handleClick}
        className="p-button-text p-0 w-2rem h-2rem fav-btn share-icon p-1"
        tooltip={tooltipText}
        tooltipOptions={{ position: "top", showDelay: 0 }}
        icon={
          <img
            src={Icon.ShareFavIcon}
            alt="Share Icon"
            style={{ width: "20px", height: "20px" }}
          />
        }
      />
    </div>
  );
};

export default ShareButton;
